import {refreshOffers} from "./utils/offers";
import {Component, h, render} from 'preact';
import {registerWidgetElement} from '@fin-cian/widget/widgetElement'
import {Provider} from 'preact-redux';
import WelcomeText from './compoments/welcomeText/WelcomeText'
import {get} from 'axios';

import store from './store/store';
import axios from "axios/index";

require('./styles/index.scss');

const DEFAULT_SIZE = 5000000;
const DEFAULT_TYPE = 'USED';
const DEFAULT_SUBTYPE = 'FLAT';

class FinanceWidgetOffers extends Component {
    render() {
        return <Provider store={store}>
            <WelcomeText/>
        </Provider>;
    }
}


function getPrice(attributes) {
    const attr = attributes.getNamedItem('price');
    if (attr) {
        try {
            return Number.parseFloat(attr.value);
        } catch (e) {
            return DEFAULT_SIZE;
        }
    }
    return DEFAULT_SIZE;
}

function getType(attributes) {
    const attr = attributes.getNamedItem('type');
    if (attr) {
        return attr.value;
    }
    return DEFAULT_TYPE;
}

function getSubtype(attributes) {
    const attr = attributes.getNamedItem('subtype');
    if (attr) {
        return attr.value;
    }
    return DEFAULT_SUBTYPE;
}

registerWidgetElement('x-finance-widget-offers',
    (element, attributes) => {
        const price = getPrice(attributes);
        const type = getType(attributes);
        const subtype = getSubtype(attributes);

        store.subscribe(() => {
            const state = store.getState();
            if (state && state.offers) {
                document.dispatchEvent(new CustomEvent(state.offers.length ? "FW-OFFERS_GOT_OFFERS" : "FW-OFFERS_NO_OFFERS"));
            }
        });
        const data = element.querySelector(`script[type="application/json"]`);

        if (data) {
            store.dispatch({
                type: 'GOT_OFFERS',
                offers: JSON.parse(data.innerText)
            })
        }
        else {
            refreshOffers(price, type, subtype).then((offers) => {
                if (offers && offers.length) {
                    axios.post("https://widget-statistics.fin.cian.ru/widgets/events/finance-widget-offers-on-card", {name: "shown"}, {withCredentials: true});
                }
            });
        }
        element.innerHTML = '';
        render(<FinanceWidgetOffers/>, element);
    },
    () => {
    });


